<!-- Draggable Horizontal Nav -->
<div class="titles">
    <h4 *ngIf="PageTitle != null">{{PageTitle}}&nbsp;</h4>
</div>

<div class="container d-flex justify-content-evenly align-items-center nav-btns-container mb-2">
    <div class="holder d-flex overflow-auto col-9 gap-1">
            <button class="col-auto" *ngIf="navButtons.add?.visibility || !navButtons?.add" kendoButton [id]="'Add_'+DomID"
                [disabled]="!CanInsert " fillMode="none" class="px-2" (click)="AddRow()"
                imageUrl="assets/icons/add_black_24dp.svg">
            </button>
    
            <button class="col-auto" *ngIf="!navButtons?.save || navButtons.save?.visibility" kendoButton [id]="'Save_'+DomID"
                [disabled]="(!CanUpdate && !CanInsert) " fillMode="none"
                [ngClass]="{'nav-save-btn': (navButtons.add?.visibility || !navButtons.add)}" class="px-3"
                (click)="Save()" value="Save" imageUrl="assets/icons/save_black_24dp (2).svg">
            </button>
    
            <button class="col-auto" *ngIf="!navButtons?.delete || navButtons.delete?.visibility" kendoButton [id]="'Delete_'+DomID"
                [disabled]="!CanDelete " fillMode="none" class="nav-delete-btn px-2" (click)="DeleteCard()"
                imageUrl="assets/icons/delet.svg">
            </button>
    
            <button class="col-auto" *ngIf="!navButtons?.cancel || navButtons.cancel?.visibility" kendoButton [id]="'Cancel_'+DomID"
                [disabled]="!CanUpdate && !CanInsert" fillMode="none"
                [ngClass]="{'nav-cancel-btn': (!navButtons.delete || navButtons.delete?.visibility)}" class="px-2"
                (click)="Cancel()" imageUrl="assets/icons/cancel_black_24dp (2).svg">
            </button>
       
        <ng-content>
        </ng-content>
    </div>
    <div class="d-flex col-3 nav-icons">
            <img *ngIf="isFilterActive"  (click)="OnOpenFilter()" src="assets/icons/mdi--filter.svg" alt="Icon" class="img-fluid col-auto">
            <img *ngIf="isSorterActive"  (click)="OnOpenSorter()" src="assets/icons/bx--sort.svg" alt="Icon" class="img-fluid col-auto">
            <img *ngIf="isRefreshActive" (click)="refresh()"      src="assets/icons/refresh.svg" alt="Icon" class="img-fluid col-auto">
            <ng-content select="right-content"></ng-content>
    </div>
</div>

<!-- end Draggable Horizontal Nav -->
